// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./ProgressIndicatorTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable selector-max-specificity -- design system */

.ProgressIndicator-module__Container__dlWrf {
    width: 100%;
    height: var(--ds-2x);
    overflow: hidden;
    background-color: var(--ds-progress-indicator-bg-color);
    border: 0;
    border-radius: 8px;
}

.ProgressIndicator-module__Container__dlWrf::-webkit-progress-bar {
    background-color: var(--ds-progress-indicator-bg-color);
}
/* The classes below can't be written as one definition due to unexpected behavior in Chrome and Safari */
.ProgressIndicator-module__Container__dlWrf::-webkit-progress-value {
    background-color: var(--ds-progress-indicator-color);
    border-radius: 8px;
    transition: width var(--ds-transition-m) var(--ds-timing-function-progress);
}

.ProgressIndicator-module__Container__dlWrf::-moz-progress-bar {
    background-color: var(--ds-progress-indicator-color);
    border-radius: 8px;
    transition: width var(--ds-transition-m) var(--ds-timing-function-progress);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `ProgressIndicator-module__Container__dlWrf`
};
export default ___CSS_LOADER_EXPORT___;
